import { render, staticRenderFns } from "./ModalCampaignDistribution.vue?vue&type=template&id=2ef205a2&scoped=true"
import script from "./ModalCampaignDistribution.vue?vue&type=script&lang=js"
export * from "./ModalCampaignDistribution.vue?vue&type=script&lang=js"
import style0 from "./ModalCampaignDistribution.vue?vue&type=style&index=0&id=2ef205a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef205a2",
  null
  
)

export default component.exports